import * as React from "react";
import { RedoclyReferenceDocs } from "@redocly/reference-docs";
export default function ApiReferenceInfo(_ref) {
  var a = _ref.store,
      b = _ref.data;
  return React.useEffect(function () {
    a.menu.renderItems[0] && "section" !== a.menu.renderItems[0].type && (a.menu.renderItems = []);
  }, [a]), /*#__PURE__*/React.createElement(RedoclyReferenceDocs, {
    store: a,
    _forceRenderInfo: !!b.redocHasInfoPage
  });
}